/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getCustomerProfile} from '../api'

 export const useQueryGetCustomerProfile = createReactQueryHook('getCustomerProfile', getCustomerProfile)
